import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../providers/userdata-model';
import { GameModel } from '../providers/game-model';

@Injectable()
export class DataExchanger {
  errorMessage: string;
  serverurl: string;

  constructor(public functions: Functions, public translate: TranslateService, public userdataModel:UserdataModel, public http: Http, public playModel: GameModel) {
    this.serverurl="http://xtribe.eu:3333/api/rubedo";
  }

  getRankingsFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = [];
      
      this.http.post(this.serverurl+"/getrankings", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          resolve(obj);
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getRankingsFromServer",error);
        });
    });
  }

  getGamesDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getgamesdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          /*console.log("GAMESDATA");
          console.log(this.playModel.gamesData);
          console.log("RESPONSE");
          console.log(obj);*/
          this.playModel.gamesData=obj;
          this.playModel.storeGamesData().then((response)=>{
            resolve("getGamesdataFromServerIsOk");
          });
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getGamesdataFromServer",error);
      });
    });
  }

   getUserGameDataFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/getusergamesdata", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          if(obj[0]){
            obj=obj[0];
          }
          
          var usergamedata=[];
          if(!obj.score || obj.score==-1){ usergamedata[0]=this.functions.emptyScore; }else{ usergamedata[0]=obj.score;}
          if(!obj.level || obj.level==-1){ usergamedata[1]=this.functions.emptyLevel; }else{ usergamedata[1]=obj.level;}
          if(!obj.collectibles || obj.collectibles==''){ usergamedata[2]=this.functions.emptyCollectibles; }else{ usergamedata[2]=JSON.parse(obj.collectibles);}
          if(!obj.booksinfo || obj.booksinfo==''){ usergamedata[3]=this.functions.emptyBooksinfo; }else{ usergamedata[3]=JSON.parse(obj.booksinfo);}

          this.userdataModel.setUserdata(
            "","","","","","","","","","","","","","","","","",
            usergamedata[0],usergamedata[1],usergamedata[2],usergamedata[3],"","","").then((response)=>{
              resolve("getUserGameDataFromServerIsOk");
            });

        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getUserGameDataFromServer",error);
        });
    });
  }

  getTextblockFromServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      var dataToSend = this.userdataModel.userdata; // level is inside userdata
      dataToSend[0].language= this.functions.language;
      dataToSend[0].difficulty= this.functions.difficulty;
      let postParams = dataToSend;
      
      this.http.post(this.serverurl+"/gettextblock", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.functions.currentTextblock=obj;
          resolve("getTextblockFromServerIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("getTextblockFromServer",error);
      });
    });
    
  }

  storeUserGamedataOnServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = {
        guidUser: this.userdataModel.getGuidUser(),
        score:this.userdataModel.getScore(),
        level:this.userdataModel.getLevel(),
        collectibles:JSON.stringify(this.userdataModel.getCollectibles()),
        booksinfo:JSON.stringify(this.userdataModel.getBooksinfo())
      };
      
      this.http.post(this.serverurl+"/storeusergamesdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeUserGamedataOnServerIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeusergamesdata",error);
      });
    });
  }

  storeGamedataOnServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.playModel.gamesData[this.playModel.getCurrentGameId()];
      
      this.http.post(this.serverurl+"/storegamedata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeGamedataOnServerIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeGamedataOnServer",error);
      });
    });
  }

  storeUserDataOnServer(){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      let postParams = this.userdataModel.userdata;
      
      this.http.post(this.serverurl+"/storeuserdata", postParams, options)
        .subscribe(data => {
          //let obj = JSON.parse(data['_body']);
          resolve("storeUserDataOnServerIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("storeUserDataOnServer",error);
      });
    });
  }

  setErrorMessage(callType, error){
    //TODO sistemare error messages and copy function from auth.js
    /*this.errorMessages.push("yea");
    this.errorMessages.push("yea2");
    console.log(this.errorMessages);*/
    var responseString:string;
    this.errorMessage="";
    responseString=error.toString();
    if(callType=="registration"){
      if(responseString.indexOf('Wrong username or password')!=-1){
        this.translate.get('userPwdWrong').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already taken')!=-1){
        this.translate.get('nameTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already registered')!=-1){
        this.translate.get('emailTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(this.errorMessage!=""){
        return;
      }
      
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
    if(callType=="login"){
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-exchanger.ts